// extracted by mini-css-extract-plugin
export default {"productDescription":"p_-z","featuredDescription":"q_-z","description":"r_-z","more":"s_-z","descriptionSku":"t_-z"};